import { render, staticRenderFns } from "./Thumbnail.vue?vue&type=template&id=09d8032c&scoped=true"
import script from "./Thumbnail.vue?vue&type=script&lang=ts&setup=true"
export * from "./Thumbnail.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./Thumbnail.vue?vue&type=style&index=0&id=09d8032c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09d8032c",
  null
  
)

export default component.exports